const _app = {
    slug: "reviews-tripadvisor"
}

export { _app }